export default __webpack_public_path__ + "static/media/logo.uhon.tech.665365de.svg";